import { Component, inject, input } from '@angular/core';
import { CeButtonComponent, CeContainerComponent, CeEmptyStateImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { Router } from '@angular/router';

@Component({
    selector: 'ce-logged-out',
    standalone: true,
    imports: [CeButtonComponent, CeContainerComponent, CeEmptyStateImports],
    template: `
        <div class="LoggedOut">
            <ce-container>
                <ce-empty-state type="unauthorized">
                    <h1 ce-empty-state-title>You've been logged out</h1>
                    <p ce-empty-state-description>{{ description() }}</p>
                    <div ce-empty-state-actions>
                        <button ce-button ce-button-type-primary (click)="signIn()">Sign in</button>
                    </div>
                </ce-empty-state>
            </ce-container>
        </div>
    `,
    styles: `
        .LoggedOut {
            animation: fadeIn 300ms ease-in forwards;
            opacity: 0;
        }

        @keyframes fadeIn {
            to { opacity: 1; }
        }
    `,
})
export class LoggedOutComponent {
    readonly #router = inject(Router);

    description = input('Sign in to continue.');
    signInRoute = input('/');

    signIn(): void {
        this.#router.navigate([this.signInRoute() ?? '/']);
    }
}
